<template>
  <div class="content-width--sm">

    <div style="max-width: 360px; margin: auto; text-align: center;">
      <!-- <img style="width: 80%;" :src="logo"/> -->
      <h1 style="line-height: 1.25em;">Thank you for submitting your film license</h1>
    </div>

    <p>
      If you haven’t already provided your video file or its url link to
      us, please do so by sending us an email at
      <a href="mailto:storytellers.global@viddsee.com">storytellers.global@viddsee.com</a>.
    </p>
    <p>
      For file transfers, feel free to use wetransfer, google drive or
      dropbox, also to 
      <a href="mailto:storytellers.global@viddsee.com">storytellers.global@viddsee.com</a>.
    </p>
    <p>
      After we have received confirmation of your file, our team of
      curators will be able to review your film!
    </p>
    <p>
      Best Regards,<br/>
      Team Viddsee<br/>
    </p>
  </div>
</template>

<script>
import logo from '@/assets/logo.png';

export default {
  data() {
    return {
      logo,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Licenses/Others/ThankYou.vue